export const API_URL = "https://fauzanocthory.github.io/kasir-app-api/db.json"
